export default __webpack_public_path__ + "static/python-robotics-b5185d0dbab13eef51757b758144612b.webp";